import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { MessageSquare } from 'lucide-react';
import type { FilterState } from '../GlobalFilters';

interface CustomerServiceTabProps {
  clientId: string;
  filters: FilterState;
}

export function CustomerServiceTab({ clientId, filters }: CustomerServiceTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <MessageSquare className="mr-2 h-5 w-5" />
          Service Client & Avis
        </CardTitle>
        <CardDescription>Satisfaction client et gestion des avis</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Données du service client en cours de chargement...</p>
      </CardContent>
    </Card>
  );
}